import { render } from "./SideNavComponent.vue?vue&type=template&id=4992204c&scoped=true"
import script from "./SideNavComponent.vue?vue&type=script&lang=ts"
export * from "./SideNavComponent.vue?vue&type=script&lang=ts"

import "./SideNavComponent.vue?vue&type=style&index=0&id=4992204c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4992204c"

export default script